<template>
  <el-dialog
    modal-class="card-dialog-wrap"
    v-model="state.zoneDialogVisble"
    append-to-body
    width="970px"
  >
    <template #header>
      <span class="max-drawer-title">{{ $t("actions.图片选择") }}</span>
    </template>
    <div class="search-bar">
      <!-- <el-input
        v-model="state.zonePicName"
        style="width: 240px"
        :placeholder="$t('form.请输入{field}', { field: $t('text.图片名') })"
        clearable
      /> -->
      <el-date-picker
        v-model="state.zonePickerDate"
        style="margin: 0 10px 0 0"
        type="date"
        value-format="YYYY-MM-DD"
        :placeholder="$t('form.请选择{field}', { field: $t('text.上传日期') })"
      />
      <el-button @click="onSearchZoneImg" type="primary">{{
        $t("actions.查询")
      }}</el-button>
    </div>
    <div v-loading="state.zoneImageLoading" class="img-list">
      <div
        :class="{
          'pic-item': true,
          'pic-item-selected': state.zoneSelectedImages[imgItem.url],
        }"
        v-for="imgItem in state.zoneImagesList"
        :key="imgItem.url"
        @click="() => toggleSelectImg(imgItem.url)"
      >
        <div class="cursor-point" style="width: 150px; height: 150px">
          <el-image :lazy="true" class="img-box" :src="imgItem.url"  referrerpolicy="no-referrer" />
        </div>
        <div
          class="img-title"
          style="
            white-space: nowrap;
            color: rgb(102, 102, 102);
            text-overflow: ellipsis;
            overflow: hidden;
          "
        >
          {{ imgItem.name && imgItem.name.split("/").pop() }}
        </div>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="confirmSelectedImages">{{
          $t("actions.选择")
        }}</el-button>
        <el-button @click="state.zoneDialogVisble = false">{{
          $t("actions.取消")
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import { Plus, ArrowDown, Delete } from "@element-plus/icons-vue";
import { defineComponent, computed, reactive, onBeforeMount, h, onMounted, watch, ref } from "vue";
import type { ComputedRef, Ref } from "vue";
import moment from "moment";
import lodash from "lodash-es";
import { useRoute } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import $ from "jquery";
import OSS from "ali-oss";
import { getOssToken } from "@user-center/api/common";
import _Upload from "element-plus/es/components/upload";
import {
  ElMessageBox,
  ElMessage,
  ElButton,
  ElDropdown,
  ElNotification,
} from "element-plus";
import { useStore, mapGetters } from "vuex";
import type { Store } from "vuex";
import type { StoreStateType } from "@user-center/store/getters";
import type { UserStateType } from "@user-center/store/modules/user";
import { $t } from "@user-center/utils/i18n.ts";
export default defineComponent({
  name: "ZoneImageManage",
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  setup(props, ctx) {
    let store: Store<StoreStateType> = useStore<StoreStateType>();
    let userinfo: any = computed(() => store.getters.userinfo);
    const state: UnwrapNestedRefs<any> = reactive({
      zoneDialogVisble: false,
      zonePicName: "",
      zonePickerDate: moment().format("YYYY-MM-DD"),
      zoneImagesList: [],
      zoneSelectedImages: {},
      zoneImageLoading: false,
    });
    const refs: any = {};
    const setRef = (el: any, key: string) => {
      refs[key] = el;
    };

    let uploading: Ref<boolean> = ref(false);

    let cosObject: OSS;
    const uploadRef: Ref<typeof _Upload | null> = ref(null);

    watch(
      () => uploading.value,
      (v: any) => {
        ctx.emit("uploading-change", v);
      }
    );

    let lastOssSign: any = null;
    function getOssTokenFn() {
      return new Promise((resolve, reject) => {
        if (lastOssSign && moment(lastOssSign.expiration).isAfter(moment())) {
          resolve(lastOssSign);
        } else {
          getOssToken()
            .then((sign: any) => {
              resolve(sign);
              lastOssSign = sign;
            })
            .catch((e: any) => {
              reject(e);
            });
        }
      });
    }
    function httpRequest(opt: any): Promise<any> {
      console.log("uploading");
      uploading.value = true;
      return new Promise((resolve, reject) => {
        getOssTokenFn()
          .then((sign: any) => {
            cosObject = new OSS({
              accessKeyId: sign.accessKeyId, // 后台的临时签名ID
              accessKeySecret: sign.accessKeySecret, // 后台的临时签名密钥
              stsToken: sign.securityToken,
              endpoint: sign.endpoint, // 后台配置的 OSS 节点
              bucket: sign.bucket, // 后台配置的 OSS 仓库名
            });

            const curTime = new Date();
            const year = curTime.getFullYear();
            const month = curTime.getMonth() + 1;
            const day = curTime.getDate();
            // 生成日期文件夹 自定义，可根据自身业务 区分文件夹。每个 ‘ / ’ 即是一级目录
            const dir =
              "images/userData/" +
              userinfo.value.id +
              "/" +
              year +
              "-" +
              (month < 10 ? "0" + month : month) +
              "-" +
              (day < 10 ? "0" + day : day) +
              "/";
            let uploadData = {
              key: "",
              name: "",
            };
            // 在文件名中追加时间戳，避免同名文件被覆盖
            const timestamp = Date.now();
            const originName = opt.file.name || "";
            const dotIndex = originName.lastIndexOf(".");
            const hasExt = dotIndex !== -1;
            const baseName = hasExt ? originName.slice(0, dotIndex) : originName;
            const ext = hasExt ? originName.slice(dotIndex) : "";
            uploadData.name = `upload_${userinfo.value.id}_${baseName}_${timestamp}${ext}`;
            cosObject
              .put(dir + uploadData.name, opt.file)
              .then((res) => {
                uploading.value = false;
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err: Error) => {
            uploading.value = false;
            if (err) {
              reject(err);
            }
          });
      });
    }

    function onSearchZoneImg() {
      openZoneDialog();
    }
    function toggleSelectImg(url: string) {
      state.zoneSelectedImages[url] = !state.zoneSelectedImages[url];
    }
    // 打开空间图片
    function openZoneDialog() {
      document.body.click();
      state.zoneSelectedImages = {};
      state.zoneDialogVisble = true;
      state.zoneImageLoading = true;
      getOssTokenFn().then(async (sign: any) => {
        cosObject = new OSS({
          accessKeyId: sign.accessKeyId, // 后台的临时签名ID
          accessKeySecret: sign.accessKeySecret, // 后台的临时签名密钥
          stsToken: sign.securityToken,
          endpoint: sign.endpoint, // 后台配置的 OSS 节点
          bucket: sign.bucket, // 后台配置的 OSS 仓库名
        });
        const listResult: any = await cosObject.list(
          {
            prefix: `images/userData/${userinfo.value.id}/${state.zonePickerDate}/`,
            delimiter: "/",
            "max-keys": 1000,
          },
          { timeout: 20000 }
        );
        state.zoneImageLoading = false;
        if (listResult.objects) {
          state.zoneImagesList = listResult.objects || [];
        }
      });
    }
    function confirmSelectedImages() {
      let zoneSelectedImages = Object.keys(state.zoneSelectedImages).filter(
        (url: string) => {
          return !!state.zoneSelectedImages[url];
        }
      );
      state.zoneSelectedImages = {};
      state.zoneDialogVisble = false;
      state.zoneImageLoading = false;
      state.zoneImagesList = [];
      ctx.emit("zone-selected", zoneSelectedImages);
    }
    return {
      setRef,
      httpRequest,

      state,
      uploading,
      onSearchZoneImg,
      toggleSelectImg,
      openZoneDialog,
      confirmSelectedImages,
    };
  },
});
</script>
<style lang="scss" scoped>
.actions-btns-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0px;
}
.actions-btn {
  margin: 0 0 5px;
  width: 150px;
}
.img-list {
  margin: 5px -5px;
}
.pic-item {
  width: 175px;
  box-sizing: border-box;
  display: inline-block;
  background-color: transparent;
  padding: 10px 10px 10px 10px;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #999;
  margin: 5px;
  cursor: pointer;
  &.pic-item-selected {
    border-width: 2px;
    border-color: var(--el-color-primary);

    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-top: 20px solid var(--el-color-primary);
      border-right: 20px solid transparent;
    }
  }
}
.img-box {
  display: block;
  margin: 0 auto;
  width: 150px;
  height: 150px;
}
.img-title {
  font-size: 14px;
  margin: 5px 0 0;
}
</style>
